import React, { useState } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';

const LedgerFilterForm = ({
  applyFilter
}) => {
  const filterInputs = {
    to_date:'',
    from_date:'',
    entity_id:''
  };
  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <DropDownInput
        label={`Entity`}
        data={[
          {name: 'Parviom', id: '2'},
          {name: 'Ovunque', id: '1'},
        ]}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, entity_id: val.id })
        }
      />
    
      <DatePicker
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, from_date: val })
        }
        label={`From Date`}
        required={false}
      />
      <DatePicker
          handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, to_date: val })
          }
          label={`To Date`}
          required={false}
      />
      
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default LedgerFilterForm;
